// keyframes
const keyframes = (keyframesName: string): string => {
  if (keyframesName === "fadeIn") {
    return ` 
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
    
        to {
          opacity: 1;
        }
      }
    `;
  }
  if (keyframesName === "fadeInUp") {
    return ` 
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translate3d(0, 100%, 0);
        }
    
        to {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }
    `;
  }
  if (keyframesName === "fadeInDown") {
    return ` 
      @keyframes fadeInDown {
        from {
          opacity: 0;
          transform: translate3d(0, -100%, 0);
        }

        to {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }
    `;
  }
  if (keyframesName === "bounceIn") {
    return `
      @keyframes bounceIn {
        from,
        20%,
        40%,
        60%,
        80%,
        to {
          animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }
    
        0% {
          opacity: 0;
          transform: scale3d(0.3, 0.3, 0.3);
        }
    
        20% {
          transform: scale3d(1.1, 1.1, 1.1);
        }
    
        40% {
          transform: scale3d(0.9, 0.9, 0.9);
        }
    
        60% {
          opacity: 1;
          transform: scale3d(1.03, 1.03, 1.03);
        }
    
        80% {
          transform: scale3d(0.97, 0.97, 0.97);
        }
    
        to {
          opacity: 1;
          transform: scale3d(1, 1, 1);
        }
      }
    `;
  }
  return null;
};

// animation CSS
const animate = (
  animationName: string,
  duration: number,
  delay: number
): string => `
  animation-duration: ${duration}s;
  animation-delay: ${delay}s;
  animation-fill-mode: both;
  animation-name: ${animationName};

  ${keyframes(animationName)};
`;

export { animate as default };
